import type { TransactionGroup } from "schema/gen/es/chiikipoint/model/v2/model_pb";
import { css } from "../../../../styled-system/css";
import { IconImage } from "../../../components/icon-image";
import { formatDate } from "../../../libs/date";
import { t } from "../../../libs/i18n";

type TransactionHeaderProps = {
  transactionGroup: TransactionGroup;
  iconUrl: string;
  title: string;
  createdAt: number;
};

export function TransactionHeader({
  iconUrl,
  title,
  createdAt,
}: TransactionHeaderProps) {
  return (
    <div
      className={css({
        display: "flex",
        gap: "16px",
      })}
    >
      <div
        className={css({
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexShrink: 0,
        })}
      >
        <IconImage src={iconUrl} alt={t("取引アイコン")} size={48} />
      </div>

      <div>
        <h1
          className={css({
            color: "text.primary",
            fontSize: "20px",
            fontWeight: 600,
            wordBreak: "break-word",
          })}
        >
          {title}
        </h1>
        <div
          className={css({
            color: "text.secondary",
            fontSize: "14px",
            fontWeight: 400,
          })}
        >
          {formatDate(createdAt * 1000, "dateTimeSlash")}
        </div>
      </div>
    </div>
  );
}
